import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { MemoryHistory } from 'history';
import { useSelector, useDispatch } from 'react-redux';

import { openExitDialog } from 'actions/exitDialog';

import applicationActions from 'common/support/applicationActions';
import device from 'common/support/device';

import Focusable from 'components/focus/Focusable';

import { toggleClosedCaptioning } from 'actions/closedCaptioning';
import { showFullScreenPlayer } from 'actions/hero';
import { VideoCtvRedux } from 'store-types';

interface AppActionsHandlerProps {
  children: ReactNode;
}

const AppActionsHandler = ({ children }: AppActionsHandlerProps) => {
  const dispatch = useDispatch();
  const history = useHistory() as MemoryHistory;
  const heroData = useSelector(
    (state: VideoCtvRedux) => state.kitchenSink?.data?.hero?.data,
  );

  const onAction = (action: string): boolean => {
    if (action === applicationActions.back) {
      history.goBack();

      try {
        if (history.entries[history.index]?.pathname === '/hero') {
          // started from hero carousel player and pressed onto an auth discovery row video
          // pressing back from login screen (/shortcode) brings you back to hero player
          const searchParams = new URLSearchParams(
            history.entries[history.index]?.search,
          );
          const videoId = searchParams.get('video');
          if (
            heroData?.find(videoItem => videoItem?.id === videoId) !== undefined
          ) {
            // play hero video if it still exists in the hero carousel
            dispatch(showFullScreenPlayer(videoId));
          } else {
            // if video no longer exists in hero carousel, go back to home
            history.goBack();
          }
        }
      } catch {
        // no-op
      }
      return true;
    }

    if (action === applicationActions.exit) {
      dispatch(openExitDialog());
      return true;
    }

    if (action === applicationActions.captions && device.useCCAppAction) {
      dispatch(toggleClosedCaptioning());
      return true;
    }

    return false;
  };

  return (
    <Focusable
      onAction={onAction}
      className={classNames('w-100', 'h-100')}
      disableFocusOnHover
      render={() => children}
    />
  );
};

export default AppActionsHandler;
